import slugify from "slugify"

export const getSlug = entry => {
  return entry.node.frontmatter.slug
    ? slugify(entry.node.frontmatter.slug)
    : slugify(entry.node.frontmatter.title.toLowerCase())
}
